import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_work_order_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { workOrderId: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ProjectId?: number, ReferenceNumber?: string, StatusId?: number, WarehouseId?: number, Status?: { DisplayName?: string }, Tasks?: { Id?: number }[], Project?: { OwnerId?: number } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.workOrderId)) {
      $missingRequiredInParams.push('\'workOrderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      workOrderId: number    }) {
        if(isNil($inParams.workOrderId)) {
          return true; 
        }
      return false;
    }
}
